import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import {
  fetchStates,
  fetchCities,
  selectStates,
  selectCities,
  clearCities,
} from '../../redux/slices/catalogSlice';

export default function LocationSelector({ onLocationChange, isLawyer = false }) {
  const dispatch = useDispatch();
  const states = useSelector(selectStates);
  const cities = useSelector(selectCities);

  const [selectedCountry, setSelectedCountry] = useState('142'); // Mexico por defecto
  const [selectedState, setSelectedState] = useState('');
  const [selectedCity, setSelectedCity] = useState('');

  // Cargar estados de México al montar el componente
  useEffect(() => {
    dispatch(fetchStates(142)); // 142 es el ID de México
  }, [dispatch]);

  const handleCountryChange = e => {
    const countryId = e.target.value;
    setSelectedCountry(countryId);
    setSelectedState('');
    setSelectedCity('');
    dispatch(clearCities());

    if (countryId) {
      dispatch(fetchStates(countryId));
    }

    updateLocation(countryId, '', '');
  };

  const handleStateChange = e => {
    const stateValue = e.target.value;
    setSelectedState(stateValue);
    setSelectedCity('');

    if (stateValue) {
      // Buscar el estado seleccionado para obtener su ID
      const selectedStateObj = states.data.find(state => state.name === stateValue);
      if (selectedStateObj) {
        dispatch(fetchCities(selectedStateObj.id));
      }
    } else {
      dispatch(clearCities());
    }

    updateLocation(selectedCountry, stateValue, '');
  };

  const handleCityChange = e => {
    const cityValue = e.target.value;
    setSelectedCity(cityValue);
    updateLocation(selectedCountry, selectedState, cityValue);
  };

  const updateLocation = (country, state, city) => {
    if (onLocationChange) {
      onLocationChange({
        country: country || '',
        state: state || '',
        city: city || '',
      });
    }
  };

  const selectClassName = `w-full px-4 py-2 border rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-colors appearance-none ${
    isLawyer
      ? 'bg-transparent border-gray-400 text-white focus:ring-gray-200'
      : 'bg-white border-gray-300 text-gray-900'
  }`;

  const labelClassName = `text-xs mb-1 ${isLawyer ? 'text-gray-300' : 'text-gray-500'}`;

  return (
    <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
      {/* País - Por ahora solo México */}
      <div className="flex flex-col">
        <label className={labelClassName}>País</label>
        <div className="relative">
          <select
            value={selectedCountry}
            onChange={handleCountryChange}
            className={selectClassName}
            disabled={true} // Solo México por ahora
          >
            <option value="142">México</option>
          </select>
          <div className="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-700">
            <svg
              className="fill-current h-4 w-4"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 20 20"
            >
              <path
                fillRule="evenodd"
                d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z"
                clipRule="evenodd"
              />
            </svg>
          </div>
        </div>
      </div>

      {/* Estado */}
      <div className="flex flex-col">
        <label className={labelClassName}>Estado</label>
        <div className="relative">
          <select
            value={selectedState}
            onChange={handleStateChange}
            className={selectClassName}
            disabled={states.loading || !selectedCountry}
          >
            <option value="">{states.loading ? 'Cargando estados...' : 'Seleccione Estado'}</option>
            {states.data.map(state => (
              <option key={state.id} value={state.name}>
                {state.name}
              </option>
            ))}
          </select>
          <div className="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-700">
            <svg
              className="fill-current h-4 w-4"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 20 20"
            >
              <path
                fillRule="evenodd"
                d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z"
                clipRule="evenodd"
              />
            </svg>
          </div>
        </div>
      </div>

      {/* Ciudad */}
      <div className="flex flex-col">
        <label className={labelClassName}>Ciudad</label>
        <div className="relative">
          <select
            value={selectedCity}
            onChange={handleCityChange}
            className={selectClassName}
            disabled={cities.loading || !selectedState}
          >
            <option value="">
              {cities.loading
                ? 'Cargando ciudades...'
                : selectedState
                  ? 'Seleccione Ciudad'
                  : 'Selecciona un estado primero'}
            </option>
            {cities.data.map(city => (
              <option key={city.id} value={city.name}>
                {city.name}
              </option>
            ))}
          </select>
          <div className="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-700">
            <svg
              className="fill-current h-4 w-4"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 20 20"
            >
              <path
                fillRule="evenodd"
                d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z"
                clipRule="evenodd"
              />
            </svg>
          </div>
        </div>
      </div>
    </div>
  );
}
